import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {ManageTagsPage} from './manage-tags';
import {TranslateModule} from "@ngx-translate/core";
import {ComponentsModule} from '../../components/components.module';
import {HeaderTitleComponentModule} from '../../components/header-title/header-title.module';

@NgModule({
  declarations: [
    ManageTagsPage,
  ],
  imports: [
    HeaderTitleComponentModule,
    IonicPageModule.forChild(ManageTagsPage),
    TranslateModule.forChild(),
    ComponentsModule
  ],
})
export class ManageTagsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/manage-tags/manage-tags.module.ts